"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateUserInfo = exports.updatePass = exports.updateInfo = exports.saveAuthRole = exports.saveAuthGroup = exports.resetPassword = exports.provinceEdit = exports.provinceDel = exports.provinceAdd = exports.logout = exports.login = exports.localBjcaLogin = exports.getUserInfoByUsername = exports.getProvince = exports.getPostListByUserId = exports.getOptionDataByFlowType = exports.getInfo = exports.getAuthRoleListByUserId = exports.getAuthGroupListByUserId = exports.deleteUserInfoById = exports.deleteBatchUserInfoById = exports.addUserInfo = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 登录
 * @param data
 * @returns {AxiosPromise}
 */
// export const login = (data) => {
//   return axios.request({
//     url: '/user/login',
//     method: 'post',
//     params: data
//   })
// }
var login = exports.login = function login(data) {
  return _api.default.request({
    url: '/auth/systemLogin/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  });
};

/**
 * 获取用户信息
 * @returns {AxiosPromise}
 */
var localBjcaLogin = exports.localBjcaLogin = function localBjcaLogin(jyId) {
  return _api.default.request({
    url: '/system/auth/bjca/local-login',
    method: 'get',
    params: {
      jyId: jyId
    }
  });
};
var getInfo = exports.getInfo = function getInfo() {
  return _api.default.request({
    url: '/system/user/getInfo',
    method: 'get'
  });
};

/**
 * 退出
 * @returns {AxiosPromise}
 */
var logout = exports.logout = function logout() {
  return _api.default.request({
    url: '/user/logout',
    method: 'get'
  });
};

/**
 * 添加用户
 * @param userInfo
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var addUserInfo = exports.addUserInfo = function addUserInfo(userInfo) {
  return _api.default.request({
    url: '/system/user/save',
    method: 'post',
    data: userInfo
  });
};

/**
 * 修改用户
 * @param userInfo
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var updateUserInfo = exports.updateUserInfo = function updateUserInfo(userInfo) {
  return _api.default.request({
    url: '/system/user/update',
    method: 'post',
    data: userInfo
  });
};

/**
 * 修改用户基本信息
 * @param userInfo
 * @returns {AxiosPromise}
 */
var updateInfo = exports.updateInfo = function updateInfo(userInfo) {
  return _api.default.request({
    url: '/user/updateUserInfo',
    method: 'post',
    data: userInfo
  });
};

/**
 * 删除用户
 * @param userInfoId
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteUserInfoById = exports.deleteUserInfoById = function deleteUserInfoById(userInfoId) {
  return _api.default.request({
    url: '/system/user/delete',
    method: 'post',
    params: {
      id: userInfoId
    }
  });
};

/**
 * 批量删除用户
 * @param userInfoIds
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteBatchUserInfoById = exports.deleteBatchUserInfoById = function deleteBatchUserInfoById(userInfoIds) {
  return _api.default.request({
    url: '/system/user/deleteBatch',
    method: 'post',
    data: userInfoIds
  });
};

/**
 * 重置密码
 * @param userInfo
 * @returns {*|AxiosPromise<any>|ClientRequest|void|ClientHttp2Stream}
 */
var resetPassword = exports.resetPassword = function resetPassword(userInfo) {
  return _api.default.request({
    url: '/system/user/resetPassword',
    method: 'post',
    data: userInfo
  });
};

/**
 * 根据用户id查询已授权的角色列表
 * @param userId
 * @returns {*|AxiosPromise<any>|ClientRequest|void|ClientHttp2Stream}
 */
var getAuthRoleListByUserId = exports.getAuthRoleListByUserId = function getAuthRoleListByUserId(userId) {
  return _api.default.request({
    url: '/system/user/getAuthRoleListByUserId',
    params: {
      userId: userId
    }
  });
};

/**
 * 保存授权角色
 * @param userInfoRoleDTO
 * @returns {*|AxiosPromise<any>|ClientRequest|void|ClientHttp2Stream}
 */
var saveAuthRole = exports.saveAuthRole = function saveAuthRole(userInfoRoleDTO) {
  return _api.default.request({
    url: '/system/user/saveAuthRole',
    method: 'post',
    data: userInfoRoleDTO
  });
};

/**
 * 根据用户id查询已授权的用户组列表
 * @param userId
 * @returns {*|AxiosPromise<any>|ClientRequest|void|ClientHttp2Stream}
 */
var getAuthGroupListByUserId = exports.getAuthGroupListByUserId = function getAuthGroupListByUserId(userId) {
  return _api.default.request({
    url: '/system/user/getAuthGroupListByUserId',
    params: {
      userId: userId
    }
  });
};

/**
 * 保存授权用户组
 * @param userInfoGroupDTO
 * @returns {*|AxiosPromise<any>|ClientRequest|void|ClientHttp2Stream}
 */
var saveAuthGroup = exports.saveAuthGroup = function saveAuthGroup(userInfoGroupDTO) {
  return _api.default.request({
    url: '/system/user/saveAuthGroup',
    method: 'post',
    data: userInfoGroupDTO
  });
};

/**
 * 根据用户名获取用户信息
 * @param username 用户名
 * @returns {*|AxiosPromise<any>|ClientRequest|void|ClientHttp2Stream}
 */
var getUserInfoByUsername = exports.getUserInfoByUsername = function getUserInfoByUsername(username) {
  return _api.default.request({
    url: '/system/user/getUserInfoByUsername',
    params: {
      username: username
    }
  });
};

/**
 * 根据用户id查询岗位列表
 * @param userId
 * @returns {*}
 */
var getPostListByUserId = exports.getPostListByUserId = function getPostListByUserId(userId) {
  return _api.default.request({
    url: '/system/user/getPostListByUserId',
    params: {
      userId: userId
    }
  });
};

/**
 * 修改密码
 * @param userInfo
 * @returns {*}
 */
var updatePass = exports.updatePass = function updatePass(userInfo) {
  return _api.default.request({
    url: '/system/user/updatePass',
    method: 'post',
    data: userInfo
  });
};
var getOptionDataByFlowType = exports.getOptionDataByFlowType = function getOptionDataByFlowType(flowType, search) {
  return _api.default.request({
    url: '/system/user/getOptionDataByFlowType',
    params: {
      flowType: flowType,
      search: search
    }
  });
};
/**
 * 描述 获取省份列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var getProvince = exports.getProvince = function getProvince(data) {
  return _api.default.request({
    url: '/province/provinceList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增省份
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var provinceAdd = exports.provinceAdd = function provinceAdd(data) {
  return _api.default.request({
    url: '/province/insertProvince',
    method: 'post',
    data: data
  });
};
/**
 * 描述 编辑省份
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var provinceEdit = exports.provinceEdit = function provinceEdit(data) {
  return _api.default.request({
    url: '/province/updateProvince',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除省份
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var provinceDel = exports.provinceDel = function provinceDel(data) {
  console.log(data);
  return _api.default.request({
    url: '/province/deleteById',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};